module.exports = __webpack_public_path__ + "img/indexnew_loadapp.34f6c988.png";